module.exports = __webpack_public_path__ + "img/logo1.fca6864a.png";